/**
 * Scroll-to-top button web component.
 * Wraps a button and smooth-scrolls to top on click.
 */
class ScrollToTopButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._handleClick = this._handleClick.bind(this);
    this.addEventListener("click", this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick);
  }

  _handleClick() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

customElements.define("scroll-to-top-button", ScrollToTopButton);
